import { connect } from 'react-redux';
import UnpostingTKSD from '../../views/Settings/UnpostingTKSD.view';
import {
  getUserGroups, getSchoolUnitsOptions, getParamPerwakilan,
  getPrmStaffKepsek, getParamOptionsAcademics, getPeriodsOptions
} from '../../states/thunks/options.thunk';
import { listBlockUnits, editParameterBK, unPostingPosition, listUnpostingTKSD } from '../../states/thunks/academics.thunk';

function mapStateToProps(state) {
  return {
    classes: state.options.classes,
    levels: state.options.levels,
    user: state.user || {},
  };
}

function mapDispatchToProps(dispatch) {
  return {
    handleListBlockUnits: (payload, goback) => dispatch(listBlockUnits(payload, goback)),
    getPrmStaffKepsekOptions: payload => dispatch(getPrmStaffKepsek(payload)),
    getUserGroups: payload => dispatch(getUserGroups(payload)),
    getSchoolUnitsOptions: payload => dispatch(getSchoolUnitsOptions(payload)),
    getParamPerwakilan: payload => dispatch(getParamPerwakilan(payload)),
    handleListUnpostingTKSD: (payload, goback) => dispatch(listUnpostingTKSD(payload, goback)),
    handleUnpostingPosition: (payload, goback) => dispatch(unPostingPosition(payload, goback)),
    handleEditParameterBK: (payload, goback) => dispatch(editParameterBK(payload, goback)),
    getParamOptionsAcademics: (payload, type) => dispatch(getParamOptionsAcademics(payload, type)),
    getPeriodsOptions: payload => dispatch(getPeriodsOptions(payload)),
    
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(UnpostingTKSD);
